import TradingPacksTable from './TradingPacksTable';

export default TradingPacksTable;
